import React from "react";
import { Box, Text, Image, Link } from "@chakra-ui/react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { accent } from "../../constants/constants";
import sydneyMap from "../../assets/images/sydney-map.png";

interface LocationBadgeProps {
  label: string;
  size?: number;
}

const LocationBadge: React.FC<LocationBadgeProps> = ({ label, size = 130 }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box position="relative" width={`${size}px`} height={`${size}px`}>
        <Box
          position="absolute"
          inset={0}
          borderRadius="full"
          border="1px solid"
          borderColor="brand.border"
          bg="brand.surface"
          overflow="hidden"
        >
          <Image
            src={sydneyMap}
            alt="Map of Sydney Harbour"
            width="100%"
            height="100%"
            objectFit="cover"
            filter="grayscale(1) invert(1) brightness(0.85) contrast(1.15)"
          />
        </Box>
        <Box
          as={FaMapMarkerAlt}
          position="absolute"
          top="-10px"
          left="50%"
          transform="translateX(-50%)"
          boxSize="28px"
          color={accent}
        />
      </Box>
      <Text mt={3} fontSize="sm" fontWeight={600} color="brand.muted">
        {label}
      </Text>
      <Link
        href="https://www.openstreetmap.org/copyright"
        isExternal
        fontSize="10px"
        color="brand.muted"
        opacity={0.6}
        mt={1}
      >
        © OpenStreetMap
      </Link>
    </Box>
  );
};

export default LocationBadge;
